import { useEffect, useRef, useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import AnimatedGrid from "./AnimatedGrid";
import hyundaiLogo from "@/assets/clients/hyundai.png";
import novoBancoLogo from "@/assets/clients/novobanco.png";
import controlLogo from "@/assets/clients/control.png";
import sportingLogo from "@/assets/clients/sporting.png";
import galpLogo from "@/assets/clients/galp.png";
import bdpLogo from "@/assets/clients/bdp.png";
import museuAroucaLogo from "@/assets/clients/museu-arouca.png";
import centroRioLogo from "@/assets/clients/centro-rio.png";
import portugalPequenitosLogo from "@/assets/clients/portugal-pequenitos.png";
import espacoValdevezLogo from "@/assets/clients/espaco-valdevez.png";
import wavecomLogo from "@/assets/clients/wavecom.png";
import piodaoLogo from "@/assets/clients/piodao.png";
import marthasLogo from "@/assets/clients/marthas.png";
import ris2048Logo from "@/assets/clients/ris2048.png";
import hugLogo from "@/assets/clients/hug.png";

type ClientItem = {
  name: string;
  logo: string;
};

const clients: ClientItem[] = [
  { name: "Hyundai", logo: hyundaiLogo },
  { name: "Novo Banco", logo: novoBancoLogo },
  { name: "Control", logo: controlLogo },
  { name: "Sporting", logo: sportingLogo },
  { name: "Galp", logo: galpLogo },
  { name: "Banco de Portugal", logo: bdpLogo },
  { name: "Museu Municipal de Arouca", logo: museuAroucaLogo },
  { name: "Centro de Interpretação do Rio", logo: centroRioLogo },
  { name: "Portugal dos Pequenitos", logo: portugalPequenitosLogo },
  { name: "Espaço Valdevez", logo: espacoValdevezLogo },
  { name: "Wavecom", logo: wavecomLogo },
  { name: "Núcleo Museológico de Piódão", logo: piodaoLogo },
  { name: "Martha's", logo: marthasLogo },
  { name: "Ris 2048", logo: ris2048Logo },
  { name: "Hug", logo: hugLogo },
];

const ClientsSection = () => {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  const isMobile = useIsMobile();

  const visibleClients = isMobile ? clients.slice(0, 10) : clients;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="clients" ref={ref} className="py-16 sm:py-24 md:py-32 relative section-light overflow-hidden">
      <AnimatedGrid />
      <div className="glow-orb w-[400px] h-[400px] bg-muted bottom-0 right-0" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <div className="mb-10 sm:mb-16">
          <span className="section-label">Clientes</span>
          <h2 className="section-heading">Marcas que confiam<br />na <span className="text-accent">EVK</span></h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 sm:gap-4">
          {visibleClients.map((client, i) => (
            <div
              key={client.name}
              className={`bg-white rounded-xl border border-border/40 shadow-sm flex min-h-24 sm:min-h-28 items-center justify-center px-4 sm:px-5 py-5 sm:py-6 transition-all duration-500 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <img
                src={client.logo}
                alt={`Logo ${client.name}`}
                loading="lazy"
                className="h-auto w-full max-h-12 sm:max-h-16 object-contain mix-blend-multiply"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
